import { PartitionPattern } from "#packages/ecma402-abstract/PartitionPattern.js";
import { invariant } from "#packages/ecma402-abstract/utils.js";
export function MakePartsList(pattern, unit, parts) {
	const patternParts = PartitionPattern(pattern);
	const result = [];
	for (const patternPart of patternParts) {
		if (patternPart.type === "literal") {
			result.push({
				type: "literal",
				value: patternPart.value
			});
		} else {
			invariant(patternPart.type === "0", `Malformed pattern ${pattern}`);
			for (const part of parts) {
				result.push({
					type: part.type,
					value: part.value,
					unit
				});
			}
		}
	}
	return result;
}
